module.exports = __webpack_public_path__ + "static/media/11@1280w.74b678d6.jpg";